import React from 'react';

const FormCheckBox = ({ click, name, className, content, checkBoxValue }) => (
  <div className={className}>
    <div className="flex justify-between items-center">
      <input
        onChange={click}
        type="checkbox"
        className="form-checkbox text-cf-300 border-solid-1 mr-1"
        checked={checkBoxValue}
        name={name}
        id={name}
      />
      <label htmlFor={name}>{content}</label>
    </div>
  </div>
);

export default FormCheckBox;
